export default __webpack_public_path__ + "static/media/Patient Education.7eedcb5f.mp4";